<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#7e5678"
    :border="true"
    inactive-color="#979799"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span class="foorterTxt">{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/home.png?d='+new Date()*1 : '/img/footer/home_active.png?d='+new Date()*1"
          :alt="$t('foorter.index')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/footer/home.png?d='+new Date()*1 : '/img/footer/home_active.png?d='+new Date()*1"
          :alt="$t('foorter.index')"
          :class="$t('foorter.index')"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>
    <!-- 预约 -->
    <van-tabbar-item to="/MessageBoard">
      <span class="foorterTxt">{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/time.png?d='+new Date()*1 : '/img/footer/time_active.png?d='+new Date()*1"
          :alt="$t('foorter.subscribe')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/footer/time.png?d='+new Date()*1 : '/img/footer/time_active.png?d='+new Date()*1"
          :alt="$t('foorter.subscribe')"
          :class="$t('foorter.subscribe')"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item>
    <!-- 中间 -->
    <van-tabbar-item to="/Lottery">
      <span class="foorterTxt">{{ $t('foorter.dating') }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/like.png?d='+new Date()*1 : '/img/footer/like_active.png?d='+new Date()*1"
          v-show="show !== 2"
        />
        <img
          :src="props.active ? '/img/footer/like.png?d='+new Date()*1 : '/img/footer/like_active.png?d='+new Date()*1"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item>
    <!-- 视频 -->
    <van-tabbar-item to="/video">
      <span class="foorterTxt">{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/video.png?d='+new Date()*1 : '/img/footer/video_active.png?d='+new Date()*1"
          :alt="$t('foorter.video')"
          v-show="show !== 3"
        />
        <img
          :src="props.active ? '/img/footer/video.png?d='+new Date()*1 : '/img/footer/video_active.png?d='+new Date()*1"
          :alt="$t('foorter.video')"
          :class="$t('foorter.video')"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item>
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span class="foorterTxt">{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/mine.png?d='+new Date()*1 : '/img/footer/mine_active.png?d='+new Date()*1"
          :alt="$t('foorter.my')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/footer/mine.png?d='+new Date()*1 : '/img/footer/mine_active.png?d='+new Date()*1"
          :alt="$t('foorter.my')"
          :class="$t('foorter.my')"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "MessageBoard") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "Lottery") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "video") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "MessageBoard") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "Lottery") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 46px;
.van-tabbar {
  height: @tabbar-height;
  background-color: #ffffff;
  box-shadow: 10px 10px 20px #495079;
}
.van-tabbar-item--active{
  background-color: #ffffff;
  
}
::v-deep .van-tabbar-item__icon {
  background: #7030a012;
    border-radius: 16px;
    width: 70%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 0;
}
::v-deep .van-tabbar-item--active .van-tabbar-item__icon {
    background: linear-gradient(90deg, #7030a0 0, #7030a0);
}
::v-deep .van-tabbar-item__icon img {
    height: @tabbar-img;
    display: block;
}
.van-tabbar-item {
  font-size: 26px;
}
.tui {
  width: 5rem;
  height: 5rem!important;
  margin-top: -7.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}
[class*="van-hairline"]::after {
  border: none !important;
}
.foorterTxt{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  font-size: 0.725rem;
  color: #7030a0;
}
.van-tabbar-item--active .foorterTxt{
  color: #7030a0;
}
</style>
